import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, RollbackOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table, Tag } from "antd";
import tagByStatus from "features/requestApproval/components/TagByStatus";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { formatDateTime } from "utils/formatter";
function formatDate({ dateString, pattern = "YYYY-MM-DD", reFormat = "DD-MM-YYYY" }) {
  if (!dateString) return;
  const date = dayjs(dateString, pattern);
  return date.format(reFormat);
}
const DocumentRequestTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false,
  isHistory = false
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  const showActionBar = isEmployee
    ? roles.includes("ACCESS_EMPLOYEE|DOCUMENT|DOCUMENT_REQUEST")
    : (!isHistory &&
      (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST") ||
        roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST")));

  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST") && !isEmployee) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST") && !isEmployee) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") && !isEmployee) || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|DOCUMENT_REQUEST"))) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|DOCUMENT_REQUEST"))) && record?.["approveStatusEn"] == 'Approved' && record?.rejectFlow == null) {
      items.push({
        key: "4",
        onClick: () => onView(record, "reject"),
        label: `${t("common.reject")}`,
        icon: (
          <RollbackOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }
  console.log("ssdad", t("document_request.label.document_form_type"));
  const columns = [
    {
      title: <div className="text-table">{t("workin_location.label.reqid")}</div>,
      dataIndex: "sequence",
      key: "sequence",
      sorter: true,
      align: "center",
      width: 140,
    },
    isHistory && {
      title: <div className="text-table">{t("workin_location.label.approvalSequence")}</div>,
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      width: 140,
      render: (_, record, index) => {
        const getApprovalOrder = () => {
          let order = 1;
          if (record.children === null) {
            order = 1;
          } else if (record.children === undefined) {
            order = index + 2;
          } else {
            order = 1;
          }
          return `${t("workin_location.label.approvalNumber")} ${order}`;
        };

        return getApprovalOrder();
      },
    },
    {
      title: <div className="text-table">{t("document_request.label.document_form_type")}</div>,
      dataIndex: "documentFormType",
      key: "documentFormType",
      sorter: true,
      width: 200,
      render: (_, record) => {
        return i18n.language === "en" ? record?.documentFormType?.nameEn : record?.documentFormType?.name

      },
    },
    {
      title: <div className="text-table">{t('document_request.label.preferred_date')}</div>,
      dataIndex: "preferredDate",
      key: "preferredDate",
      sorter: true,
      width: 160,
      render: (_, record) => {
        return formatDate({ dateString: record?.preferredDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })
      }
    },
    {
      title: <div className="text-table">{t('document_request.label.submission_date')}</div>,
      dataIndex: "submissionDate",
      key: "submissionDate",
      sorter: true,
      width: 170,
      render: (_, record) => {
        return formatDate({ dateString: record?.submissionDate, reFormat: i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB" })
      }
    },
    {
      title: <div className="text-table">{t('document_request.label.receiving_method')}</div>,
      dataIndex: "receivingMethod",
      key: "receivingMethod",
      sorter: true,
      width: 180,
      render: (_, record) => {
        if (record?.receivingMethod == "self_service") {
          return i18n.language == "en" ? "Self service" : "รับด้วยตนเอง"
        } else if (record?.receivingMethod == "app") {
          return i18n.language == "en" ? "Application" : "แอป";
        } else if (record?.receivingMethod == "email") {
          return i18n.language == "en" ? "Email" : "อีเมล";
        } else {
          return "-";
        }
      }
    },
    {
      title: <div className="text-table">{t('document_request.label.language_format')}</div>,
      dataIndex: "languageFormat",
      key: "languageFormat",
      width: 170,
      sorter: true,
      render: (_, record) => {
        if (record?.languageFormat == "both") {
          return i18n.language == "en" ? "Both" : "ทั้งคู่"
        } else if (record?.languageFormat == "th") {
          return i18n.language == "en" ? "Thai" : "ไทย";
        } else if (record?.languageFormat == "en") {
          return i18n.language == "en" ? "English" : "อังกฤษ";
        } else {
          return "-";
        }
      }
    },
    {
      title: <div className="text-table">{t("shift.label.description")}</div>,
      dataIndex: "description",
      key: "description",
      width: 170,
    },
    isHistory && {
      title: <div className="text-table">{t('วันที่อนุมัติ')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      width: 160,
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    isHistory && {
      title: <div className="text-table">{t('request_all.approver')}</div>,
      dataIndex: "approverBy",
      key: "approverBy",
      align: "center",
      width: 140,
      render: (_, record) => {
        if (record?.approverBy?.nameAndSurname !== null && record?.approverBy?.nameAndSurnameEn !== null) {
          return i18n.language === 'en' ? record?.approverBy?.nameAndSurnameEn : record?.approverBy?.nameAndSurname
        } else if (record?.approverBy?.name !== null && record?.approverBy?.nameEn) {
          return i18n.language === 'en' ? record?.approverBy?.nameEn : record?.approverBy?.name
        }
        return "-"
      }
    },
    {
      title: <div className="text-table">{t('step.status')}</div>,
      dataIndex: "status",
      sorter: true,
      key: "status",
      width: 150,
      align: "center",
      // render: (text, record) => <Tag color="green">{t("shift.label.approved")}</Tag>,
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    // !isHistory && (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|DOCUMENT_REQUEST") ? actionBar() : {})
    showActionBar ? actionBar() : {}
  ].filter(Boolean);

  function actionBar() {
    if (!isEmployee || roles.includes("ACCESS_EMPLOYEE|DOCUMENT|DOCUMENT_REQUEST")) {
      return {
        title: <div className="text-table">{ }</div>,
        key: "action",
        align: "center",
        width: 120,
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: readMode(_.approveStatusEn, record)
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      }
    } else {
      return {}
    }
  }
  const scroll = columns.reduce((sum, column) => sum + column.width, 0);

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={processedDataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
      scroll={{ x: scroll }}
    />
  );
};

export default DocumentRequestTable;
